import {
  type ComponentPropsWithoutRef,
  type PropsWithChildren,
  memo,
} from "react";

import { Splide, type SplideProps, SplideSlide } from "@splidejs/react-splide";

import "@splidejs/splide/css/core";

type CarouselProps = PropsWithChildren & SplideProps;

const CarouselBase = ({ children, ...splideProps }: CarouselProps) => {
  return <Splide {...splideProps}>{children}</Splide>;
};

export const Carousel = memo(CarouselBase);

type SlideProps = PropsWithChildren &
  ComponentPropsWithoutRef<typeof SplideSlide>;

const SlideBase = ({ children, ...splideProps }: SlideProps) => {
  return <SplideSlide {...splideProps}>{children}</SplideSlide>;
};

export const Slide = memo(SlideBase);
export { SplideTrack as Track } from "@splidejs/react-splide";
export { CarouselArrows } from "@react/components/Carousel/CarouselArrows.view";
export { CarouselArrow } from "@react/components/Carousel/CarouselArrow.view";
export {
  CarouselPaginationDots,
  onPaginationUpdated,
} from "@react/components/Carousel/CarouselPaginationDots.view";
